import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2023 MalwareInfo. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
